import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';

export class TechnologieWaermeerzeugung extends BaseModel {
    // properties
    id: number | null = null;
    i18n_key: string | null = null;
    code: number | null = null;
    bezeichnung: string | null = null;

    getClassName(): string {
        return 'TechnologieWaermeerzeugung';
    }
}

export class TechnologieWaermeerzeugungCollection extends BaseCollection<TechnologieWaermeerzeugung> {
    protected modelCls = TechnologieWaermeerzeugung;

    public getModelClassName(): string {
        return 'TechnologieWaermeerzeugung';
    }
}

let _globalTechnologieWaermeerzeugungCollection: TechnologieWaermeerzeugungCollection | null = null;

/**
 * global (single instance) collection: To be used where a global, shared instance can be used.
 * Note that this collection MUST NOT be filered / ordered on other places, as it is a shared instance!
 * @returns
 */
export function globalTechnologieWaermeerzeugungCollection(): TechnologieWaermeerzeugungCollection {
    if (!_globalTechnologieWaermeerzeugungCollection) {
        _globalTechnologieWaermeerzeugungCollection = new TechnologieWaermeerzeugungCollection();
        _globalTechnologieWaermeerzeugungCollection.setQueryParams({
            sort: [
                {
                    property: 'code',
                    direction: 'asc',
                },
                {
                    property: 'id',
                    direction: 'asc',
                },
            ],
        });
        _globalTechnologieWaermeerzeugungCollection.query();
    }
    return _globalTechnologieWaermeerzeugungCollection;
}
